import { PopulationPropsMap } from '../const/population-props-map.const';
import { Population } from '../enum/population.enum';
import { currentMainState } from '../population-select.state';

export function addToSelection(
    that: any,
    population: Population,
    id: number,
    label: string,
    singlePopulationSelect: boolean,
): void {
    const state = currentMainState(that);

    if (singlePopulationSelect) {
        state.selected.clear();
        state.selectedAsArray = [];
    }

    state.lastSelectedItem = {
        population,
        populationProps: PopulationPropsMap[population],
        id,
        label,
    };

    state.selected.add(state.lastSelectedItem);

    state.selectedAsArray.push({
        population,
        id,
        label,
    });
}
